var render = function render() {
  var _vm$statusTags$_vm$in, _vm$statusTags;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "top-info wlc-f-c"
  }, [_c("div", {
    staticClass: "info-left wlc-f-c"
  }, [_c("div", {
    staticClass: "back-icon wlc-f-c wlc-pointer",
    on: {
      click: _vm.back
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-left"
  }), _c("span", [_vm._v("返回")])]), _c("el-divider", {
    attrs: {
      direction: "vertical"
    }
  }), _c("div", {
    staticClass: "status wlc-f-c",
    style: {
      backgroundColor: (_vm$statusTags$_vm$in = _vm.statusTags[_vm.info.status]) === null || _vm$statusTags$_vm$in === void 0 ? void 0 : _vm$statusTags$_vm$in.color
    }
  }, [_vm._v(" " + _vm._s((_vm$statusTags = _vm.statusTags[_vm.info.status || 0]) === null || _vm$statusTags === void 0 ? void 0 : _vm$statusTags.label) + " ")]), _c("span", [_vm._v(_vm._s(_vm.info.categoryName))]), _c("el-divider", {
    attrs: {
      direction: "vertical"
    }
  }), _c("div", {
    staticClass: "other-info"
  }, [_c("span", {
    staticClass: "label"
  }, [_vm._v("创建时间")]), _c("span", [_vm._v(_vm._s(_vm.info.createAt))]), _c("span", {
    staticClass: "label"
  }, [_vm._v("跟进人")]), _c("span", [_vm._v(_vm._s(_vm.info.followName || "--"))])])], 1), _c("div", {
    staticClass: "info-right wlc-f-c"
  }, [_vm.info.consultationCount > 1 ? _c("div", {
    staticClass: "count wlc-pointer",
    on: {
      click: _vm.goConsultationHistory
    }
  }, [_vm._v(" 咨询历史 x" + _vm._s(_vm.info.consultationCount) + " ")]) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };